import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
import prepareFetchParamsMixin from '../../mixins/prepareFetchParamsMixin'

export default {
  mixins: [prepareQueryParamsMixin, prepareFetchParamsMixin],
  name: 'PrivacyPolicy',
  data () {
    return {}
  },
  mounted () {
    // window.analytics.page('PrivacyPolicy')
    window.analytics.identify('PrivacyPolicy', {
      path: '/PrivacyPolicy'
    })
  },
  components: {},
  computed: {},
  methods: {}
}
